module.exports = __webpack_public_path__ + "img/fatture_clienti_invoiceweb.73acc7d8.png";